import BlogHomeList from '@/components/sections/builder/elements/body/blog-home/post-list';
import BlogHomeSubtitle from '@/components/sections/builder/elements/body/blog-home/subtitle';
import BlogHomeTitle from '@/components/sections/builder/elements/body/blog-home/title';
import { BlogHomeElementDataType } from '@/components/sections/builder/elements/body/blog-home/type';
import ElementContent from '@/components/sections/builder/elements/body/blog-home/content';
import ElementSetting from '@/components/sections/builder/elements/body/blog-home/setting';
import { BetweenHorizontalStart } from 'lucide-react';

export const defaultData: BlogHomeElementDataType = {
  name: 'Blog',
  contentAlign: 'center',
  enableCarousel: false,
  autoplay: false,
  changeSlidesEvery: 5,
};

export const ElementPreviewIcon = BetweenHorizontalStart;

const BlogHome = {
  type: 'blog_home',
  group: 'body',
  defaultData,
  Element: ElementContent,
  Setting: ElementSetting,
  PreviewIcon: BetweenHorizontalStart,
  defaultChilds: [BlogHomeTitle, BlogHomeSubtitle, BlogHomeList],
  childs: [BlogHomeTitle, BlogHomeSubtitle, BlogHomeList],
};

export default BlogHome;
